module.exports = __webpack_public_path__ + "static/media/zoleLose_25_50.7d0b722a.png";